import ComponentModule from "@eisinc/Overrides/Components/ManageShareListModal";

export * from "@eisinc/Overrides/Components/ManageShareListModal";

export default ComponentModule;
